module.exports = ({ NPM_CLIENT }) => `// npm
npm i ${NPM_CLIENT} --save

// yarn
yarn add ${NPM_CLIENT}
`
